import { ToolBarConfig } from '../RichTextEditor';
import { WPMedia } from './toolbarButtons';

export const toolbar: ToolBarConfig = {
	image: {
		component: WPMedia,
	},
};
